module.exports = __webpack_public_path__ + "da47a32808ff83b505e7731f4a68a0f1.jpg";